import type { ReactNode } from 'react'
import { CheckIcon, Heading, TriangleExclamationIcon } from '@quickmd-llc/design-system'

interface FormSectionCardProps {
  title: string
  showIndicator: boolean
  isValid: boolean
  children: ReactNode
}

export function FormSectionCard({ title, showIndicator, isValid, children }: FormSectionCardProps) {
  return (
    <div className='rounded-large border border-border-medium bg-white'>
      <div className='flex items-center gap-sp-1 border-b border-border-medium px-sp-3 py-sp-2'>
        <Heading level='h3'>{title}</Heading>
        {showIndicator && isValid ?
          <CheckIcon iconSize='s' className='text-text-success' aria-label='Section complete' />
        : null}
        {showIndicator && !isValid ?
          <TriangleExclamationIcon iconSize='s' className='text-text-error' aria-label='Section has errors' />
        : null}
      </div>
      <div className='p-sp-3'>{children}</div>
    </div>
  )
}
